import { filter_day, filter_month, filter_week } from '../../../../../views/marketing/overview/PeriodFilter';

export default {
  filters: {
    [filter_day]: 'Dzień',
    [filter_week]: 'Tydzień',
    [filter_month]: 'Miesiąc',
    null: 'Łącznie',
  },
};
